import { mediaData } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              热播剧集推荐
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              精选当下最受欢迎的电视剧，每一部都值得追
            </p>
          </div>

          <div className="flex flex-col gap-5 md:gap-6">
            {mediaData.map((item) => (
              <div
                key={item.id}
                className="group flex flex-col md:flex-row bg-background-100 rounded-lg border border-secondary-200/70 overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
              >
                <div className="relative w-full md:w-64 lg:w-72 shrink-0" style={{ aspectRatio: '16/10' }}>
                  <img
                    src={item.image}
                    alt={`木瓜影视${item.title}`}
                    title={`木瓜影视-${item.title}-高清在线观看`}
                    className="w-full h-full object-cover object-top md:group-hover:scale-105 transition-transform duration-500"
                    onError={(e) => {
                      const target = e.currentTarget;
                      const parent = target.parentElement;
                      if (parent) parent.style.display = 'none';
                    }}
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
                  <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-sm text-foreground-500">{item.subtitle}</p>
                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed line-clamp-3">
                    {item.description}
                  </p>
                  <div className="mt-4 flex items-center gap-3">
                    <span className="inline-flex items-center gap-1 text-xs text-accent-600 font-medium">
                      <i className="ri-play-circle-line text-sm"></i>
                      立即观看
                    </span>
                    <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
                      <i className="ri-heart-line text-sm"></i>
                      收藏
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}